export enum TemplateFieldGroupTypes {
  New = 'New',
  Default = 'Default',
}
